export const MODAL_TYPES = {
  LOAD_TEMPLATE_UPLOAD: 'LOAD_TEMPLATE_UPLOAD',
  ONLINE_GRID: 'ONLINE_GRID',
  DIRECT_ONLINE_GRID: 'DIRECT_ONLINE_GRID',
  PENDING_FORM: 'PENDING_FORM',
  CONFIRM_SUBMISSION: 'CONFIRM_SUBMISSION',
  ACCEPT_SUBMISSION: 'ACCEPT_SUBMISSION',
  ZERO_COST_SUCCESS: 'ZERO_COST_SUCCESS',
};
